export default "__VITE_ASSET__CqCpkGWf__"